import { SModel } from "servisofts-model";
import Action from "./Action";
import Reducer from "./Reducer";

export default new SModel<Action, Reducer>({
    info: {
        component: "tipo_asiento"
    },
    Columns: {
        "key": { type: "text", pk: true },
        "fecha_on": { type: "timestamp", label: "Fecha de registro" },
        "key_usuario": { type: "text", fk: "usuario" },
        "estado": { type: "integer" },
        "descripcion": { type: "text", editable: true, },
    },
    Action,
    Reducer,
});